// src/services/catalogosService.js
import { apiClient } from './api';

/**
 * Servicio para manejar catálogos contables (cuentas, centros, clasificadores)
 */
export const catalogosService = {
  /**
   * Obtener lista de cuentas contables
   * @param {boolean} soloActivas - Filtrar solo cuentas activas
   * @param {string} rutEmpresa - RUT de la empresa para filtrar (opcional)
   * @returns {Promise<Array>} - Promesa con la lista de cuentas
   */
  async getCuentas(soloActivas = true, rutEmpresa = null) {
    let endpoint = `/rcv/cuentas?activas_only=${soloActivas}`;
    if (rutEmpresa) {
      endpoint += `&rut_empresa=${rutEmpresa}`;
    }
    return apiClient.get(endpoint);
  },

  /**
   * Obtener lista de centros de costo
   * @param {boolean} soloActivos - Filtrar solo centros activos
   * @param {string} rutEmpresa - RUT de la empresa para filtrar (opcional)
   * @returns {Promise<Array>} - Promesa con la lista de centros
   */
  async getCentros(soloActivos = true, rutEmpresa = null) {
    let endpoint = `/rcv/centros?activos_only=${soloActivos}`;
    if (rutEmpresa) {
      endpoint += `&rut_empresa=${rutEmpresa}`;
    }
    return apiClient.get(endpoint);
  },

  /**
   * Obtener lista de clasificadores
   * @param {string} tipo - Tipo de clasificador para filtrar (opcional)
   * @param {boolean} soloActivos - Filtrar solo clasificadores activos
   * @param {string} rutEmpresa - RUT de la empresa para filtrar (opcional)
   * @returns {Promise<Array>} - Promesa con la lista de clasificadores
   */
  async getClasificadores(tipo = null, soloActivos = true, rutEmpresa = null) {
    let endpoint = `/rcv/clasificadores?activos_only=${soloActivos}`;
    if (tipo) {
      endpoint += `&tipo=${tipo}`;
    }
    if (rutEmpresa) {
      endpoint += `&rut_empresa=${rutEmpresa}`;
    }
    return apiClient.get(endpoint);
  },

  /**
   * Crear una nueva cuenta contable
   * @param {Object} cuenta - Datos de la cuenta
   * @returns {Promise<Object>} - Promesa con la cuenta creada
   */
  async crearCuenta(cuenta) {
    return apiClient.post('/rcv/cuentas', cuenta);
  },

  /**
   * Crear un nuevo centro de costo
   * @param {Object} centro - Datos del centro
   * @returns {Promise<Object>} - Promesa con el centro creado
   */
  async crearCentro(centro) {
    return apiClient.post('/rcv/centros', centro);
  },

  /**
   * Crear un nuevo clasificador
   * @param {Object} clasificador - Datos del clasificador
   * @returns {Promise<Object>} - Promesa con el clasificador creado
   */
  async crearClasificador(clasificador) {
    return apiClient.post('/rcv/clasificadores', clasificador);
  },
};